import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import NavbarAll from "../Navbar/NavbarAll";
import "./StudentProfile.css";

function getInitial(name) {
  const s = (name || "?").trim();
  return s.charAt(0).toUpperCase();
}

/** Student / deep-link profile only — teachers use QariStudentProfile */
export default function StudentProfile({ user: hifzUser }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [student, setStudent] = useState(location.state?.student || null);
  const [loading, setLoading] = useState(!location.state?.student);
  const [error, setError] = useState("");
  const apiURL = process.env.REACT_APP_API_URL;

  const params = new URLSearchParams(location.search);
  const deepLinkToken = params.get("token");
  const backFrom = location.state?.from || "dashboard-student";

  const goBack = () => {
    const studentPayload = location.state?.student || student;
    const search = location.search;

    if (backFrom === "progress") {
      navigate({
        pathname: "/dashboard-student/progress",
        search,
        state: { student: studentPayload, role: "student" },
      });
      return;
    }
    if (backFrom === "attendance") {
      navigate({
        pathname: "/dashboard-student/attendance",
        search,
        state: { student: studentPayload, role: "student" },
      });
      return;
    }
    navigate({
      pathname: "/dashboard-student",
      search,
      state: studentPayload ? { student: studentPayload, role: "student" } : undefined,
    });
  };

  useEffect(() => {
    if (location.state?.student) {
      setStudent(location.state.student);
      setLoading(false);
      return;
    }

    const loadProfile = async () => {
      setLoading(true);
      setError("");
      try {
        if (deepLinkToken) {
          const res = await axios.get(`${apiURL}/students/by-token/${deepLinkToken}`);
          setStudent({ ...res.data, id: res.data.uid, uid: res.data.uid });
          return;
        }

        const token = localStorage.getItem("token");
        const userId = hifzUser?.userId || localStorage.getItem("userId");
        if (!userId || !token) {
          setError("Please log in to view your profile.");
          return;
        }

        const res = await axios.get(`${apiURL}/users/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setStudent({ ...res.data, id: res.data.uid, uid: res.data.uid });
      } catch (err) {
        console.error("Failed to load profile", err);
        setError(
          err.response?.data?.error ||
            "Could not load profile. Try again from the dashboard."
        );
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, [location.state?.student, deepLinkToken, apiURL, hifzUser?.userId]);

  const deepLinkUrl = student?.deepLinkToken
    ? `https://zakariamasjid.com/dashboard-student?token=${student.deepLinkToken}`
    : student?.deepLink || null;

  const copyDeepLink = () => {
    if (!deepLinkUrl) return;
    navigator.clipboard?.writeText(deepLinkUrl).then(() => alert("Link copied!"));
  };

  return (
    <>
      <NavbarAll />
      <div className="hifz-profile-wrapper">
        <div className="hifz-profile-topbar" role="banner">
          <button type="button" className="hifz-profile-back-btn" onClick={goBack}>
            ← Back
          </button>
          <h1 className="hifz-profile-title">My Profile</h1>
        </div>

        <main className="hifz-profile-main">
          {loading && <div className="hifz-profile-loading">Loading profile…</div>}

          {!loading && error && (
            <div className="hifz-profile-error">
              <p>{error}</p>
              <button type="button" className="hifz-profile-back-btn" onClick={goBack}>
                ← Back to dashboard
              </button>
            </div>
          )}

          {!loading && !error && student && (
            <div className="hifz-profile-card">
              <div className="hifz-profile-avatar" aria-hidden="true">
                {getInitial(student.name)}
              </div>
              <h2 className="hifz-profile-name">{student.name}</h2>
              <p className="hifz-profile-email">{student.email}</p>

              {deepLinkUrl && (
                <div className="hifz-profile-deeplink">
                  <span className="hifz-profile-deeplink-label">Your portal link</span>
                  <p className="hifz-profile-deeplink-url">{deepLinkUrl}</p>
                  <button
                    type="button"
                    className="hifz-profile-copy-btn"
                    onClick={copyDeepLink}
                  >
                    Copy link
                  </button>
                </div>
              )}
            </div>
          )}
        </main>
      </div>
    </>
  );
}
